import { render, staticRenderFns } from "./InformationOrganization.vue?vue&type=template&id=0013dc85&scoped=true"
import script from "./InformationOrganization.vue?vue&type=script&lang=js"
export * from "./InformationOrganization.vue?vue&type=script&lang=js"
import style0 from "./InformationOrganization.vue?vue&type=style&index=0&id=0013dc85&prod&scoped=true&lang=css"
import style1 from "./InformationOrganization.vue?vue&type=style&index=1&id=0013dc85&prod&lang=css"
import style2 from "./InformationOrganization.vue?vue&type=style&index=2&id=0013dc85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013dc85",
  null
  
)

export default component.exports